module.exports = __webpack_public_path__ + "assets/Canva_icon_15x15.4ba03b9d.svg";